<template lang="pug">
Card.selections-card
    template(#header)
        .title {{ $t('selections.houseTypology.title') }}
    template(#content)
        .typologies-wrapper 
            div(v-for="item in paginatedTypologies" :key="item.code" )
                Card.typology-card(
                    :id="item.code"
                    :class="houseTypologySelected && houseTypologySelected.code === item.code ? 'typology-selected' : '', paginatedTypologies.length === 1 ? 'unique' : ''"
                    @click="setHouseTypology(item)"
                )
                    template(#header)
                        img.image(:src="item.imgUrl" alt="")
                    template(#content)
                        .text {{ item.description }} 
        Paginator(v-if="filteredHouseTypologies.length > rows" :rows="rows" :totalRecords="filteredHouseTypologies.length" @page="onPageChange")
</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { computed, defineComponent, ref } from "vue";
import { storeToRefs } from "pinia";
import Paginator, { PageState } from "primevue/paginator";
import Card from "primevue/card";
import { HouseTypology } from "@/types";

export default defineComponent({
  name: "HouseTypology",
  components: {
    Card,
    Paginator,
  },
  props: {
    items: {
      type: Number,
    },
  },
  setup(props) {
    const { filteredHouseTypologies, houseTypologySelected } = storeToRefs(
      useSelections()
    );
    const first = ref(0);
    const rows = ref(props.items ? props.items : 3);

    const onPageChange = (event: PageState) => {
      first.value = event.first;
    };
    const paginatedTypologies = computed(() =>
      filteredHouseTypologies.value.slice(first.value, first.value + rows.value)
    );

    function setHouseTypology(typology: HouseTypology) {
      houseTypologySelected.value = typology;
    }

    return {
      filteredHouseTypologies,
      onPageChange,
      rows,
      paginatedTypologies,
      setHouseTypology,
      houseTypologySelected,
    };
  },
});
</script>
<style scoped lang="scss">
.typologies-wrapper {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  & > div {
    width: 30%;
  }
  .typology-card {
    margin: 1rem;
    min-height: 250px;
    border: solid 2px transparent;
    cursor: pointer;
    .text {
      text-align: center;
    }
    &:hover {
      border: solid 2px;
    }
    &.typology-selected {
      border: solid 2px;
    }
    :deep(.p-card-header) {
      padding: 0;
      height: 170px;
    }
    .image {
      height: 170px;
      width: 100%;
      object-fit: cover;
    }
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    & > div {
      width: 80%;
      max-width: 360px;
    }
  }
  @media screen and (max-width: 540px) {
    & > div {
      width: 90%;
    }
  }
  @media screen and (max-width: 440px) {
    & > div {
      width: 100%;
    }
  }
}
</style>
